$(document).ready(function() {

  $('.js-toggle-fund').on('ajax:success', function(e) {
    window.location.reload();
  });

  $('.js-add-comparator').on('ajax:success', function(e) {
    [data, status, xhr] = e.detail;

    if (!data.limited) {
      $(this).toggleClass('o-options__compare-active');
    }
    else {
      $(document).trigger('init:modal', $('.modal-comparator-limited').html());
      $('#modal-receiver').find('.modal-container').removeClass('close');
    }
  });

  $('.js-partner-subscription').on('ajax:success', function(e) {
    [data, status, xhr] = e.detail;

    $(document).trigger('init:modal', $('.modal-partner-subscription').html());
  });
});
